export const selectRecommendations = state => state.recommendations.data

export const selectLoadingRecommendations = state => state.recommendations.loading
